// src/components/expenses/CreateExpenseCategoryDialog.jsx
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../hooks/AuthContext";

export const ExpenseCategoryDialog = ({ open, onClose, onSuccess }) => {
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;

  if (!open) return null;

  const handleSubmit = async () => {
    if (!categoryName.trim()) return toast.error("Please enter a category name");

    const payload = {
      categoryName,
      createdBy: user?.employeeProfile?._id || user?._id,
    };

    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}categoryExpense`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Expense category created successfully!");
      setCategoryName("");
      onSuccess?.(res.data);
      onClose();
    } catch (error) {
      console.error("Error creating category:", error);
      toast.error(error.response?.data?.message || "Failed to create category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 w-96">
        <h2 className="text-lg font-semibold mb-4">Create Expense Category</h2>

        <input
          type="text"
          placeholder="Enter category name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          className="border w-full p-2 rounded-md outline-none focus:outline-none focus:ring-0 mb-4"
        />

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-[#2C4E86] text-white rounded-md hover:bg-blue-900 disabled:opacity-50"
          >
            {loading ? "Creating..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};
